import ANCHOR, { A } from '../../DOM/a/anchor/ANCHOR.js';
import Constructable, { Construct } from '../../../interface/Constructable.js';
import DL, { DD, DT } from '../../DOM/LIST/dl/DL.js';
import EL from '../../EL/EL.js';
import UL, { LI } from '../../DOM/LIST/ul/UL.js';
import CITE from '../../DOM/cite/CITE.js';
import FOOTER from '../../DOM/footer/FOOTER.js';
import HEADER from '../../DOM/header/HEADER.js';
import HEADING from '../../DOM/heading/HEADING.js';
import HR from '../../DOM/hr/HR.js';
import ICON from '../../SVG/icon/ICON.js';
import IMG from '../../DOM/img/IMG.js';
import LABEL from '../../DOM/form/label/LABEL.js';
import OL from '../../DOM/LIST/ol/OL.js';
import P from '../../DOM/p/P.js';
import SPAN from '../../DOM/span/SPAN.js';
import STRING from '../../../STRING.js';
import TABLE from '../../DOM/table/TABLE.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import { makeStruct } from '../../../enums/MODELS.js';
// Model Structure
export const contentAttr = makeAttrStruct([
    ['name', 'content'],
    ['class']
]);
export const contentData = makeDataStruct([]);
export const contentModel = makeStruct([
    ['attributes', contentAttr],
    ['data', contentData]
]);
/** A Generic element that is capable of constructing common content elements */
export default class CONTENT extends EL {
    // declare public el: HTMLDivElement; // Using HTMLDivElement as a base for CONTENT elements
    constructor(node, element, model) {
        super(node, element, model);
        this.addClass('content');
        this.implement(new Constructable(this));
        this.addConstructor('A', this.addAnchor.bind(this));
        this.addConstructor('ANCHOR', this.addAnchor.bind(this));
        //this.addConstructor('ARTICLE', this.addArticle.bind(this));
        this.addConstructor('CITE', this.addCite.bind(this));
        //this.addConstructor('DIV', this.addDiv.bind(this));
        this.addConstructor('FOOTER', this.addFooter.bind(this));
        //this.addConstructor('FORM', this.addForm.bind(this));
        this.addConstructor('HEADER', this.addHeader.bind(this));
        this.addConstructor('HEADING', this.addHeading.bind(this));
        this.addConstructor('HR', this.addHR.bind(this));
        this.addConstructor('IMG', this.addImage.bind(this));
        this.addConstructor('LABEL', this.addLabel.bind(this));
        this.addConstructor('P', this.addP.bind(this));
        //this.addConstructor('SECTION', this.addSection.bind(this));
        this.addConstructor('SPAN', this.addSpan.bind(this));
        this.addConstructor('UL', this.addUL.bind(this));
    }
    getName() {
        // return this.model.attributes.name;
        return this.attributes.name;
    }
    /** Adds a paragraph to this element */
    addAnchor(model) {
        return this.addChild(new ANCHOR(this, model));
    }
    /** Adds a Cite to this element */
    addCite(model) {
        return this.addChild(new CITE(this, model));
    }
    /** Adds a footer to this element */
    addFooter(model) {
        return this.addChild(new FOOTER(this, model));
    }
    /** Adds a header to this element */
    addHeader(model) {
        return this.addChild(new HEADER(this, model));
    }
    /** Adds a heading to this element */
    addHeading(model) {
        return this.addChild(new HEADING(this, model));
    }
    /** Adds a Horizontal Rule to this element */
    addHR(model) {
        return this.addChild(new HR(this, model));
    }
    /** Adds an ICON to this element */
    addIcon(model) {
        return this.addChild(new ICON(this, model));
    }
    /** Adds an image to this element */
    addImage(model) {
        return this.addChild(new IMG(this, model));
    }
    /** Adds a label to this element */
    addLabel(model) {
        return this.addChild(new LABEL(this, model));
    }
    /** Adds a paragraph to this element */
    addP(model) {
        return this.addChild(new P(this, model));
    }
    /** Adds a Span to this element */
    addSpan(model) {
        return this.addChild(new SPAN(this, model));
    }
    /** Adds a table to this element */
    addTable(model) {
        return this.addChild(new TABLE(this, model));
    }
    /** Adds an unordered list to this element */
    addUL(model) {
        return this.addChild(new UL(this, model));
    }
    /** Adds an ordered list to this element */
    addOL(model) {
        return this.addChild(new OL(this, model));
    }
    /** Adds a definition list to this element */
    addDL(model) {
        return this.addChild(new DL(this, model));
    }
}
export { A, ANCHOR, CITE, Constructable, Construct, DD, DL, DT, EL, FOOTER, HEADER, HR, ICON, LABEL, LI, P, SPAN, STRING, TABLE, UL };
